<template>
  <v-app>
    <v-app-bar
      app
      clipped-right
      :color="undefined"
    >
    <v-app-bar-nav-icon @click.stop="drawer = !drawer" :disabled="!company || wizard"></v-app-bar-nav-icon>
    <!-- <v-toolbar-title>DreamROI v2.0</v-toolbar-title> -->
      <!--
      <v-divider vertical class="mx-5" />
      -->
      <v-toolbar-items class="ml-5" v-if="!$vuetify.breakpoint.mobile">
        <!--
        <v-breadcrumbs large dark class="white--text text--white" color="secondary" :items="breadcrumbs">
          <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
          </template>
          
          <template v-slot:item="{ item }">
            
            <v-breadcrumbs-item class="white--text text--white" color="white"
              :to="item.to"
              :disabled="item.disabled"
              :exact="item.exact"
            >
            {{ item.text }}
            </v-breadcrumbs-item>

    </template>

        </v-breadcrumbs>
        -->
      
      <v-btn v-for="i in breadcrumbs" :key="i.to"
        :to="i.to"
        :icon="i.iconOnly"
        :text="!i.iconOnly"
        :exact="i.exact"
      >
      <v-icon v-if="i.icon" :left="!i.iconOnly">{{ i.icon }}</v-icon>
        <span v-if="!i.iconOnly">{{ i.text }}</span>
      </v-btn>
      
      <v-menu v-if="isHelpdesk"
        bottom
        close-delay="100"
        content-class="rounded"
        right
        max-height="500"
        offset-y
        open-delay="60"
        open-on-hover
        transition="slide-y-transition"
      >
      <template #activator="{ on, attrs }">
      <v-btn text v-bind="attrs"
          v-on="on">{{ $t('helpdesk.title') }}<v-icon right>$dropdown</v-icon>
      </v-btn>
      </template>
      <v-list dense>
        <v-list-item to="/helpdesk">
          <v-list-item-icon>
            <v-icon >$helpdesk</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{$t('allProjects.title')}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/running-campaigns">
          <v-list-item-icon>
            <v-icon >$runningCampaigns</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('campaigns.running.title') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/newsletter-templates">
          <v-list-item-icon>
            <v-icon >$newsletterTemplate</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('newsletterTemplates.title') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      </v-menu>
      
      </v-toolbar-items>
      <v-spacer></v-spacer>


      <toolbar-language />
      <!--
      <toolbar-notifications />
      -->
      <v-btn id="pfid1618817866" icon>
          <v-icon>$notifications</v-icon>
      </v-btn>
      <!--
      <v-btn id="pfid1660120565"  icon>
          <v-icon large color="info">$supportChat</v-icon>
      </v-btn>
      -->
      <v-btn
        href="https://www.dreamroi.com/knowledgebase/"
        target="_blank"
        icon
      >
        <v-icon>$help</v-icon>
      </v-btn>
      
      <toolbar-user v-if="authState == 'signedin'" />

      <!--
      <v-btn
        to="/profile"
        icon
      >
        <v-icon>$profile</v-icon>
      </v-btn>
      -->
    </v-app-bar>
    <v-snackbar app v-model="notification" :timeout="notificationData.timeout || 10000" :color="notificationData.error ? 'error' : 'success'">
      {{ notificationData.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="notification = false"
        >
          {{$t('dialog.close')}}
        </v-btn>
      </template>
    </v-snackbar>
    <v-main>
      <v-alert class="mx-3 mt-8 mb-n8" v-if="showConfirmInstructions" colored-border border="left" type="warning">
        {{$t('auth.verification')}}
      </v-alert>
      <amplify-authenticator v-if="authState !== 'signedin'" :initial-auth-state="initialAuthState" username-alias="email"></amplify-authenticator>
      <template v-if="authState == 'signedin'">
      <router-view />
      </template>
    </v-main>
  </v-app>
</template>

<script>
//import Login from './components/Login';

import { onAuthUIStateChange } from '@aws-amplify/ui-components'
import { mapState, mapGetters } from "vuex";
import ParseRoute from "@/mixins/parse-route";
import LoadEntitities from "@/mixins/load-entities";
import Drawer from "@/mixins/drawer";
//import ToolbarNotifications from "@/components/toolbar/ToolbarNotifications"
import ToolbarUser from "@/components/toolbar/ToolbarUser"
import ToolbarLanguage from "@/components/toolbar/ToolbarLanguage"

export default {
  name: 'App',
  mixins: [ParseRoute, LoadEntitities, Drawer],
  components: {
    //ToolbarNotifications,
    ToolbarUser,
    ToolbarLanguage
  },

  data: () => ({
    initialAuthState: null,
    showConfirmInstructions: false,
    firstLogin: false,
    firstLoad: true
  }),
  computed: {
    notification: {
      get() {
        return this.$store.state.ui.notification;
      },
      set(value) {
        this.$store.commit('ui/notification', { value });
      }
    },
    ...mapState('auth', ['user', 'authState']),
    ...mapState('ui', ['notificationData', 'notificationTimeout', 'wizard', 'locale']),
    ...mapGetters('auth', ['isHelpdesk'])
  },
  methods: {
    initProductFruits() {
      console.debug('loading product fruits');
      window.productFruitsUser = { username: this.user.attributes.sub, // REQUIRED, must be unique 
                             email: this.user.attributes.email,
                             //firstname: '<<REPLACE>>',
                             //lastname: '<<REPLACE>>',
                             //signUpAt: '<<REPLACE>>', // Sign up date (yyyy-mm-ddThh:mm:ss) 
                             role: this.isHelpdesk ? 'helpdesk' : 'user',
                             //props: { customProp1: '<<REPLACE>>' } 
                             };
      (function(w,d,u,c,l){
        w.productFruits=w.productFruits||{};
        w.productFruits.language=l;w.productFruits.code=c;
        var a=d.getElementsByTagName('head')[0];
        var r=d.createElement('script');r.async=1;
        r.src=u+'?c='+c;
        a.appendChild(r);
      })(window,document,'https://app.productfruits.com/static/script.js','vJCEyNWyjC4Qfc4-',this.locale); // Replace 'en' with a proper language code
    },
    prefill() {
      if(this.$route.query.domain) {
        this.$store.commit('domains/prefill', {name: decodeURIComponent(this.$route.query.domain)});
      }
      if(this.$route.query.currency) {
        this.$store.commit('domains/prefill', {currency: decodeURIComponent(this.$route.query.currency)});
      }
      if(this.$route.query.timezone) {
        this.$store.commit('domains/prefill', {timezone: decodeURIComponent(this.$route.query.timezone)});
      }
      if(this.$route.query.company) {
        this.$store.commit('companies/prefill', {name: decodeURIComponent(this.$route.query.company)});
      }
      if(this.$route.query.country) {
        this.$store.commit('companies/prefill', {country: decodeURIComponent(this.$route.query.country)});
      }
      if(this.$route.query.street) {
        this.$store.commit('companies/prefill', {street: decodeURIComponent(this.$route.query.street)});
      }
      if(this.$route.query.city) {
        this.$store.commit('companies/prefill', {city: decodeURIComponent(this.$route.query.city)});
      }
      if(this.$route.query.zip) {
        this.$store.commit('companies/prefill', {zip: decodeURIComponent(this.$route.query.zip)});
      }
      if(this.$route.query.crno) {
        this.$store.commit('companies/prefill', {crNo: decodeURIComponent(this.$route.query.crno)});
      }
      
    },
    shopifyPrefill() {
      if(this.$route.params.shopifyStore) {
        this.$store.commit('domains/prefill', {productFeedURL: this.$route.params.shopifyStore, platform: 'SHOPIFY'});
      }
    }
  },
  created() {
    if(this.$route.name == 'register' || this.$route.name == 'register-shopify') {
      this.initialAuthState = 'signup';
      this.prefill();
      if(this.$route.name == 'register-shopify') {
        this.shopifyPrefill();
      }
      this.$router.push({name: 'home'});
    }

    if(this.$route.query.error) {
      this.$store.dispatch('ui/notify', { text: this.$t(this.$route.query.error), error: true})
    }

    // seems that route change handler in the load-entities mixin handles the loading...
    onAuthUIStateChange((authState, authData) => {
      console.debug('auth stage changed', authState);
      this.$store.commit('auth/authState', {value: authState });
      this.$store.commit('auth/user', {value: authData });
      // this executes after successfull login
      // this is needed in case route doesnt change when user logs in
      if(authState == 'confirmSignUp') {
        this.firstLogin = true;
        this.showConfirmInstructions = true;
      } else {
        this.showConfirmInstructions = false;
      }
      
      if(authState == 'signedin') {
        //console.debug('state is sign in, loading entities');
        if(!this.firstLoad) {
          return;
        }
        this.firstLoad = false;
        this.loadEntities();
        this.initProductFruits();
        if(this.firstLogin) {
          this.$store.dispatch('auth/createACContact', { email: authData.attributes.email, phone: authData.attributes.phone_number});
          if(this.$gtm) {
            this.$gtm?.trackEvent({
              'email': authData.attributes.email,
              'phone': authData.attributes.phone_number,
              'event': 'dreamroi_registration'
            });
          }
          this.firstLogin = false;
        }
        
       if(this.$gtm) {
        console.debug(`Sending login to GTM`);
        this.$gtm?.trackEvent({
          'group': this.isHelpdesk ? 'helpdesk' : 'user', /// helpdesk/user
          'email': this.user.attributes.email,
          'event': 'dreamroi'
       });
      }
      }
    })
    // this executes immediatelly after load if user is already signed in
    // probably not needed as the above code runs after page refresh
    /*
    if(this.authState == 'signedin') {
      console.debug('loading entities directly');
      this.loadEntities();
    }
    */
  },
  beforeDestroy() {
    return onAuthUIStateChange;
  }
};
</script>
